import Color from "color";
import { getShapeComponent } from "./Shapes/ShapeFactory";
import { bgToTextColor } from "@mixitone/util";

interface Props {
  color: string;
  className?: string;
  size: number;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  shape?: string;
}

export const ShapedDot: React.FC<Props> = ({ color, className, style, size, children, shape = "circle" }) => {
  const textColor = bgToTextColor[color] || (Color(color).isDark() ? "white" : "black");
  const ShapeComponent = getShapeComponent(shape);

  return (
    <ShapeComponent
      color={color}
      size={size}
      className={className}
      style={{
        color: textColor,
        ...style,
      }}
    >
      {children}
    </ShapeComponent>
  );
};
